<template>
	<div>
		<svg width="44px" height="44px" viewBox="0 0 44 44" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
			<g id="Graph" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g>
					<g id="Icon-/-Tab-Bar-Icon">
						<rect id="bg-tabbar-icon" x="0" y="0" width="44" height="44"></rect>
					</g>
					<path d="M10.56,24.64 C12.0180317,24.64 13.2,25.8219683 13.2,27.28 L13.2,39.6 C13.2,41.0580317 12.0180317,42.24 10.56,42.24 L5.28,42.24 C3.82196827,42.24 2.64,41.0580317 2.64,39.6 L2.64,27.28 C2.64,25.8219683 3.82196827,24.64 5.28,24.64 L10.56,24.64 Z M24.64,3.52 C26.0980317,3.52 27.28,4.70196827 27.28,6.16 L27.28,39.6 C27.28,41.0580317 26.0980317,42.24 24.64,42.24 L19.36,42.24 C17.9019683,42.24 16.72,41.0580317 16.72,39.6 L16.72,6.16 C16.72,4.70196827 17.9019683,3.52 19.36,3.52 L24.64,3.52 Z M38.72,14.08 C40.1780317,14.08 41.36,15.2619683 41.36,16.72 L41.36,39.6 C41.36,41.0580317 40.1780317,42.24 38.72,42.24 L33.44,42.24 C31.9819683,42.24 30.8,41.0580317 30.8,39.6 L30.8,16.72 C30.8,15.2619683 31.9819683,14.08 33.44,14.08 L38.72,14.08 Z" id="Combined-Shape" :fill="color" fill-rule="nonzero"></path>
				</g>
			</g>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgBank',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
	},
};
</script>

<style scoped>

</style>